import React, { HTMLAttributes } from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"
import { RemixIcon } from "@/components/ui/atoms"

const tagVariants = cva(
  "inline-flex py-4 px-5 justify-center items-baseline gap-3 label-m",
  {
    variants: {
      variant: {
        accent: "bg-accent-400 rounded-100",
        accentPicture: "bg-accent-400 rounded-tr-100 rounded-bl-100",
        light: "bg-neutral-300 py-[10.25px] rounded-100",
        ghost: "bg-transparent text-neutral-400 px-0",
        ghostDark:
          "flex items-center bg-transparent justify-start text-neutral-500 px-0",
      },
    },
  }
)

type TagProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof tagVariants> & {
    icon?: string
    label: string
  }

const Tag = ({ variant, icon, label, className }: TagProps) => {
  return (
    <span className={cn(tagVariants({ variant }), className)}>
      {icon ? (
        <RemixIcon
          name={icon}
          className={cn(
            "shrink-0",
            variant === "ghost" ? "fill-neutral-400" : "fill-neutral-500"
          )}
        />
      ) : null}
      {label}
    </span>
  )
}

export { Tag, tagVariants, type TagProps }
